import { createApp } from 'vue'
import App from './App.vue'

// Create and mount the app
createApp(App).mount('#app')
